<template>
	<div v-if="isProd">
    <prod-header></prod-header>
	</div>
  <div v-else>
    <dev-header></dev-header>
  </div>
</template>

<script>
import cache from '../config/cache'
import urls from '../util/urls'
import service from '../config/service'

export default {
  name: 'top-header',
  data () {
    return  {
      isProd: process.env.NODE_ENV === 'production' ? true : false
    }
  },
  components: {
    prodHeader: resolve => require(['./prod-header'],resolve),
    devHeader: resolve => require(['./dev-header'],resolve),
  }
}
</script>